export enum UploadError {
  General = 'wmp_error.general',
  InvalidSession = 'wmp_error.invalid_session',
  SessionExpired = 'wmp_error.session_expired',
  MissingWixSession = 'wmp_error.missing_wix_session',
  SizeLimit = 'wmp_error.file_size_exceeded_limit',
  IncorrectFileInfo = 'wmp_error.incorrect_file_info',
  InvalidFile = 'wmp_error.invalid_file',
  UnsupportedFormat = 'wmp_error.unsupported_format',
  UnsupportedExtension = 'wmp_error.unsupported_file_extension',
  UnsupportedMediaType = 'wmp_error.unsupported_media_type',
  MIMEMismatch = 'wmp_error.mime_type_mismatch',
  WavMissingHeader = 'wmp_error.wav_invalid_missing_header',
  WavMissingChunk = 'wmp_error.wav_invalid_format_chunk_missing',
  WavUnsupportedStereoOnly = 'wmp_error.wav_unsupported_stereo_only',
  WavUnsupportedSampleRate = 'wmp_error.wav_unsupported_sample_rate',
  WavUnsupportedSampleSize = 'wmp_error.wav_unsupported_sample_size',
  WavUnsupportedChunkSize = 'wmp_error.wav_unsupported_format_chunk_size',
  WavUnsupportedFormat = 'wmp_error.wav_unsupported_format',
  UnsupportedVideoCodec = 'wmp_error.unsupported_video_codec',
  UnsupportedAudioCodec = 'wmp_error.unsupported_audio_codec',
  MaxVideoBitrateExceeded = 'wmp_error.max_video_bitrate_is_exceeded',
  VideoDurationMismatch = 'wmp_error.video_duration_mismatch',
  ExternalFileAuthorization = 'wmp_error.external_file_authorization',
  ExternalFileForbidden = 'wmp_error.external_file_forbidden',
  ImageDimentionsExceeded_limit = 'wmp_error.image_dimentions_exceeded_limit',
  CorruptedImage = 'wmp_error.corrupted_image',
  Mp4UnsupportedFormat = 'wmp_error.mp4_unsupported_format',
  Mp4UnsupportedStereoOnly = 'wmp_error.mp4_unsupported_stereo_only',
  WmaUnsupportedBitrate = 'wmp_error.wma_unsupported_bitrate',
  WmaUnsupportedBitrateLossy = 'wmp_error.wma_unsupported_bitrate_lossy',
  AacUnsupportedFormat = 'wmp_error.aac_unsupported_format',
  Mp4UnsupportedSampleRate = 'wmp_error.mp4_unsupported_sample_rate',
  Mp4UnsupportedBitrate = 'wmp_error.mp4_unsupported_bitrate',
  Mp3UnsupportedStereoOnly = 'wmp_error.mp3_unsupported_stereo_only',
  Mp3UnsupportedFormat = 'wmp_error.mp3_unsupported_format',
  ZeroSizeFile = 'wmp_error.zero_size_file',
  FontsNotAllowed = 'wmp_error.fonts_not_allowed',
  SyncImportFailed = 'wmp_error.sync_import_failed',
  InvalidRequest = 'wmp_error.invalid_request',
  MissingMandatoryParameter = 'wmp_error.missing_mandatory_parameter',
  QuotaTotalVideoDurationExceeded = 'wmp_error.site_quota_total_video_duration_exceeded',
  QuotaSingleVideoDurationExceeded = 'wmp_error.site_quota_single_video_duration_exceeded',
  QuotaFreeVideoDurationExceeded = 'wmp_error.site_quota_free_video_duration_exceeded',
  QuotaTotalStorageExceeded = 'wmp_error.site_quota_total_storage_exceeded',
  SVGNoVisualContent = 'wmp_error.svg_content_rejection_1208',
  SVGEmbeddedImage = 'wmp_error.svg_content_rejection_1211',
  UploadStopped = 'files-manager.upload-tab-body-stopped',
  NoResponseError = 'files-manager.upload-tab-body-no-response-error',
  FailedResume = 'files-manager.upload-tab-body-fail-resume',
  NetworkGeneral = 'wmp_error.network_general',
}
